import { CallState, ICorpPerson, IPerson } from "redmond";
import { IDeleteUserPassengerRequest } from "../../../api/v0/user-passengers/deleteUserPassenger";
import { IUpdateUserPassengerRequest } from "../../../api/v0/user-passengers/updateUserPassenger";
import * as actionTypes from "./constants";

export interface IUpdateUserPassengerArgs extends IUpdateUserPassengerRequest {
  isNewTraveler?: boolean;
  updatePassport?: boolean;
  updateDriverLicense?: boolean;
  updateFrequentFlyer?: boolean;
  defaultTravelerId?: string;
  entryPoint?: string;
}

export interface IUpdateUserPassenger {
  type: actionTypes.UPDATE_USER_PASSENGER;
  payload: IUpdateUserPassengerArgs;
}

export const updateUserPassenger = (
  payload: IUpdateUserPassengerRequest,
  isNewTraveler?: boolean,
  updatePassport?: boolean,
  updateDriverLicense?: boolean,
  updateFrequentFlyer?: boolean,
  defaultTravelerId?: string,
  entryPoint?: string
) => ({
  type: actionTypes.UPDATE_USER_PASSENGER,
  payload: {
    ...payload,
    isNewTraveler,
    updatePassport,
    updateDriverLicense,
    updateFrequentFlyer,
    defaultTravelerId,
    entryPoint,
  },
});

export interface IDeleteUserPassengerArgs extends IDeleteUserPassengerRequest {}

export const deleteUserPassenger = (payload: IDeleteUserPassengerArgs) => ({
  type: actionTypes.DELETE_USER_PASSENGER,
  payload,
});

export interface IDeleteUserPassenger {
  type: actionTypes.DELETE_USER_PASSENGER;
  payload: IDeleteUserPassengerArgs;
}

export const fetchUserPassengers = () => ({
  type: actionTypes.FETCH_USER_PASSENGERS,
});

export interface IFetchUserPassengers {
  type: actionTypes.FETCH_USER_PASSENGERS;
}

export interface ISetUserPassengers {
  type: actionTypes.SET_USER_PASSENGERS;
  userPassengerCallState: CallState;
  userPassengers: IPerson[] | ICorpPerson[];
}

export const setUserPassengers = (args: {
  userPassengerCallState: CallState;
  userPassengers: IPerson[] | ICorpPerson[];
}): ISetUserPassengers => ({
  type: actionTypes.SET_USER_PASSENGERS,
  ...args,
});

export interface IFetchCorpUserPassengers {
  type: actionTypes.FETCH_CORP_USER_PASSENGERS;
}

export const fetchCorpUserPassengers = (): IFetchCorpUserPassengers => ({
  type: actionTypes.FETCH_CORP_USER_PASSENGERS,
});

export interface ISetUserPassengersCallState {
  type: actionTypes.SET_USER_PASSENGERS_CALL_STATE;
  callState: CallState;
}

export const setUserPassengersCallState = (
  callState: CallState
): ISetUserPassengersCallState => ({
  type: actionTypes.SET_USER_PASSENGERS_CALL_STATE,
  callState,
});

export type PackagesBookActions =
  | IUpdateUserPassenger
  | IDeleteUserPassenger
  | IFetchUserPassengers
  | ISetUserPassengers
  | IFetchCorpUserPassengers
  | ISetUserPassengersCallState;
